export enum CompanyType {
  AGENCY = "AGENCY",
  CLIENT = "CLIENT",
  LEGAL = "LEGAL",
  COMPANY = "COMPANY",
  TBMC = "TBMC"
}
